import React, { PureComponent } from 'react';
import { Currency } from '~/Api/Currency';
import ProductPriceSelectPopover from '~/ProductPriceSelectPopover';
import Button from '~/UI/Button';
import buttonIconStyles from '~/UI/Button/icon.less';
import Icon from '~/UI/Icon';
import LayoutConstraint from '~/UI/LayoutConstraint/LayoutConstraint';

import styles from './styles.less';

interface Props {
	currency: string | null;
	currencies: Currency[] | null;
	filterCalculatedPrice: boolean;
	priceType: string | null;
	style: React.CSSProperties;
	onPriceChanged(currency: string | null, priceType: string | null, filterCalculatedPrice: boolean): void;
}

export default class Header extends PureComponent<Props, { showPriceSelect: boolean }> {
	public static defaultProps = {
		style: null,
	};

	state = {
		showPriceSelect: false,
	};

	pricePopoverContainerElement = React.createRef<HTMLSpanElement>();

	private readonly popoverClosed = (event: MouseEvent) => {
		const element = this.pricePopoverContainerElement.current;

		// @ts-expect-error Argument of type 'EventTarget | null' is not assignable to parameter of type 'Node | null'.
		if (element !== null && event.currentTarget !== element && !element.contains(event.currentTarget)) {
			this.setState({ showPriceSelect: false });
		}
	};

	private readonly selectedPriceChanged = (
		currency: string | null,
		type: string | null,
		filterCalculatedPrice: boolean
	) => {
		this.setState({ showPriceSelect: false });
		this.props.onPriceChanged(currency, type, filterCalculatedPrice);
	};

	public render() {
		const { style, currency, currencies, priceType, filterCalculatedPrice } = this.props;
		const { showPriceSelect } = this.state;

		const priceButton = (
			<Button
				data-testid='product-table-price-button'
				styles={buttonIconStyles}
				onClick={() => this.setState({ showPriceSelect: !showPriceSelect })}
			>
				<Icon name='currency'>price and currency</Icon>
			</Button>
		);

		return (
			<div className={styles.header} style={style}>
				<div className={styles.addOrRemoveCell} />
				<div className={styles.countryCell}>Country</div>
				<div className={styles.brandCell}>Brand name</div>
				<div className={styles.mahCell}>Company</div>
				<div className={styles.dosageCell}>Dosage Form</div>
				<div className={styles.dosageStrengthCell}>Dosage strength</div>
				<div className={styles.packageCell}>Package</div>
				<div className={styles.priceCell}>Price</div>
				<div className={styles.priceTypeCell}>
					<span ref={this.pricePopoverContainerElement}>
						<LayoutConstraint reference={priceButton}>
							{({ referenceRect }) =>
								showPriceSelect ? (
									<ProductPriceSelectPopover
										currencies={currencies}
										currentCurrency={currency}
										currentPriceType={priceType}
										filterCalculatedPrice={filterCalculatedPrice}
										referenceRect={referenceRect}
										width={405}
										onClose={this.popoverClosed}
										onChange={this.selectedPriceChanged}
									/>
								) : null
							}
						</LayoutConstraint>
					</span>
				</div>
				<div className={styles.packageForCalculationCell}>{'Number of\xa0units in\xa0package'}</div>
				<div className={styles.priceCell}>Unit price</div>
			</div>
		);
	}
}
